import Vue from "vue";
import { Component } from "vue-property-decorator";
import moment from "moment";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { ParametresInstance } from "../../Controls/Parameters";
import { SocieteParametrageDto } from "../../../dto/GenApi.iNotPaie.Dto/SocieteParametrageDto";
import { ParametreDto } from "../../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import { RoleConstants } from "../../Controls/EventConstants";
import { LicensingManagerInstance } from "../../Controls/LicensingManager";
import { License } from "../../../shared/Enums/Licensing/License";

@Component
export default class ParametrageSocieteComponent extends Vue {
	public isModified = false;
	public SocieteParametrage: SocieteParametrageDto = { Id: 0 };
	public scenarios: ParametreDto[] = [];
	public scenariosEffectif: ParametreDto[] = [];
	public scenariosSociete: ParametreDto[] = [];
	public typesScenario: ParametreDto[] = [];
	public typeScenarioEffectif = "EFFEC";
	public typeScenarioSociete = "SOCTE";
    public dateClotureExerciceComptable = "";
    public canModifyIcare = false;

    public dataReady = false;
    public canDisplayTarification = false;

	public Init(): void {
        this.dataReady = false;
        this.canModifyIcare = ParametresInstance.userHasRole(RoleConstants.Administrateur) ||
            ParametresInstance.userHasRole(RoleConstants.AdministrateurPST);

    	if (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.Code != undefined) { // parametrages
   		    ServicesFactoryInstance.SocieteService.getSocieteParametrage(ParametresInstance.societeCourante.Code, (data) => {
    			this.SocieteParametrage = data;
                this.dateClotureExerciceComptable = moment.utc(data.DateClotureExerciceComptable).format("YYYY-MM-DD");

                if (ParametresInstance.isPst && ParametresInstance.userHasRole(RoleConstants.AdministrateurPST)) {
                    this.canDisplayTarification = true;
                }

    			// scénarios
    			ServicesFactoryInstance.ScenariosService.getScenarios((data) => {
                    this.scenarios = data;

    				// types scenarios
    				ServicesFactoryInstance.ScenariosService.getTypesScenarios((data) => {
    					this.typesScenario = data;
    					this.scenariosEffectif = this.scenarios.filter(s => s.CodeCategorie == this.typeScenarioEffectif);
    					this.scenariosSociete = this.scenarios.filter(s => s.CodeCategorie == this.typeScenarioSociete);
    					this.isModified = false;
    					this.$emit("isModified", false);
    					this.dataReady = true;
    					this.$forceUpdate();
    				});
    			});
    		});
   	    }
	}

	public annuler(): void {
    	this.Init();
	}

	public champModified(): void {
    	this.isModified = true;
    	this.$emit("isModified", true);
	}

	public update(): void {
    	this.dataReady = false;
    	this.SocieteParametrage.DateClotureExerciceComptable = moment.utc(this.dateClotureExerciceComptable).toDate();

    	ServicesFactoryInstance.SocieteService.updateSocieteParametrage(this.SocieteParametrage, (data) => {
    		this.SocieteParametrage = data;
    		this.Init();
    		NotificationServiceInstance.SendSuccess("La société a bien été modifiée.");
    	});
    }

    // Détermine si on peut afficher la saisie des identifiants primobox
    public showPrimoboxIdentifiant(): boolean {
        return ParametresInstance.userHasRole(RoleConstants.Administrateur) && LicensingManagerInstance.hasLicense(License.Primobox);
    }

    public toggleTarification(): void {
        if (ParametresInstance.isPst && ParametresInstance.userHasRole(RoleConstants.AdministrateurPST)) {
            this.SocieteParametrage.NouveauTarif = !this.SocieteParametrage.NouveauTarif;
            this.champModified();
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/ficheSociete/parametrage/parametrageSociete.ts